export default `{
  "_type": newsletter._type,
  "headline": newsletter.headline,
  "title": newsletter.title,
  "bgColor": newsletter.bgColor
}`;
